<template>
  <div class="material-input-holder" :class="parentClass">

    <input v-if="type === 'text'" type="text" :class="labelClass" :id="id" class="material-input" v-model="valueMutatedStr" @focus="focus" @blur="blur">
    <input v-if="type === 'email'" type="email":class="labelClass" :id="id" class="material-input" v-model="valueMutatedStr" @focus="focus" @blur="blur">
    <input v-if="type === 'password'" type="password":class="labelClass" :id=id class="material-input" v-model="valueMutatedStr" @focus="focus" @blur="blur">
    <input v-if="type === 'number'" type="number"  :class="labelClass" :id=id class="material-input" v-model="valueMutatedNumber" @focus="focus" @blur="blur">
    <label class="material-input-label" :class="labelClass" :for="id">{{label}}</label>
    
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'material-input',
    props: {
      parentClass: {
        type: String,
        required: false,
        default: '',
      },
      label: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'text',
      },
      valueStr: {
        type: String,
        default: '',
      },
      valueNumber: {
        type: Number,
      },
      value: Number,
    },
    methods: {
      focus() {
        this.isFocused = true;
      },
      blur() {
        this.isFocused = false;
      },
    },
    watch: {
      valueMutatedStr(input) {
        this.$emit('inputStr', input);
      },
      valueMutatedNumber(input) {
        this.$emit('inputNumber', Number(input));
      },
      valueNumber(input) {
        this.valueMutatedNumber = input;
      },
    },
    computed: {
      labelClass() {
        if (this.valueMutatedStr.length > 0 || this.valueMutatedNumber > 0 || this.isFocused) {
          return 'active';
        }
        return '';
      },
    },
    data() {
      return {
        valueMutatedStr: this.valueStr,
        valueMutatedNumber: this.valueNumber,
        isFocused: false,
        id: Math.random(),
      };
    },
  };
</script>

<style type="text/css" >
  .material-input-holder{
    position: relative;
    height: 37px;
  }
  
  .material-input{
    width: 100%;
    box-sizing: border-box;
    outline: none;
    box-shadow: none;
    font-family: 'Roboto', sans-serif;
    border: 1px solid #C4CBDF;
    border-radius: 3px;
    height: 37px;

    padding: 10px 10px 5px;

    -webkit-box-shadow: none;

    line-height: 23px;
    padding-bottom: 0;
    vertical-align: bottom;

    font-size: 14px;
    color: #4A4A4A;
  }
  .material-input:focus{
    border: 2px solid #45DE91;
    padding-left: 9px;
  }

  .material-input-label{
    position: absolute;
    top:0;
    line-height: 40px;
    left: 10px;
    transition: all 0.3s ease-out;
    font-size: 10px;
    color: #C2C2C2;
}

  .material-input-label.active{
    font-size: 10px;
    line-height: 18px;
    color:#aaa;
  }
  
</style>


// WEBPACK FOOTER //
// InputMaterial.vue?4eeb05b9